import { useEffect } from 'react'
import {getRelatedConceptByBookId} from '../../../services/sBook/book.service'
import {getContractById, getAllContracts} from '../../../services/sBook/contract.service'
import {getProjectById, getAllProjects} from '../../../services/sBook/project.service'

import { treeify } from '../../../common/Helpers'

const useGetRelatedConceptsByType = (elementList, setElementList, relatedConcept, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = (relatedConcept.relatedConceptTypeId === 1) ? await getAllProjects() : await getAllContracts();
                const response = serviceResponse.data.data;
                let response_aux = treeify(response !== null ? response : [], 'id', null, 'children', (relatedConcept.relatedConceptTypeId === 1) ? 'code' : 'code', 'name')

                setElementList(response_aux);
            }
            catch (error) {
            }
        }
        
        if (elementList === null && isPanelOpen === true && relatedConcept.relatedConceptTypeId !== 0) {
            getData()
        }
    }, [elementList, setElementList, relatedConcept, isPanelOpen]);
}

const useGetRelatedConceptReference = (bookObj, relatedConceptItem, setItem, relatedConceptIsCleared, setterRetRelatedConceptHasPartys, setterRelatedMainBookName) => {    
    useEffect(()=> {
        const getData = async () => {
            let serviceResponse = null;

            try {
                serviceResponse = await getRelatedConceptByBookId(bookObj.id);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data.length > 0 ? serviceResponse.data.data[0] : null;

                    setterRetRelatedConceptHasPartys && setterRetRelatedConceptHasPartys(response.hasPartys)
                    setterRelatedMainBookName && setterRelatedMainBookName(response.book_name_principal)
                    
                    setItem && setItem(response);
                }

            }
            catch (error) {
            }
        }
        
        if (bookObj !== null) {
            if (bookObj.id !== null && relatedConceptItem === null && relatedConceptIsCleared === false) {
                getData()
            }            
        }

    }, [bookObj, relatedConceptItem, setItem, relatedConceptIsCleared, setterRetRelatedConceptHasPartys, setterRelatedMainBookName]);
}

const useGetRelatedConceptById = (itemId, item, setItem, relatedConceptTypeId) => {    
    useEffect(()=> {
        const getData = async () => {
            let serviceResponse = null;

            try {
                switch (relatedConceptTypeId) {
                    case 1:
                        serviceResponse = await getProjectById(itemId);
                        break;
                    case 2:
                        serviceResponse = await getContractById(itemId);
                        break;
                    default:
                        break;
                }

                const response = serviceResponse.data;

                if (response.succeeded) {
                    setItem(response.data);
                }
                else {
                    setItem({ id: 0 });
                }
            }
            catch (error) {
                setItem({ id: 0 });
            }
        }
        
        if (itemId !== null && (item === null || item.id === null)) {
            getData()
        }
    }, [item, itemId, setItem, relatedConceptTypeId]);
}

export {
    useGetRelatedConceptsByType,
    useGetRelatedConceptById,
    useGetRelatedConceptReference
}